import { BaseReducer } from '@hobs/utils/baseReducer';
import { GET, CREATE } from '@hobs/constants/discussion';

class Discussion extends BaseReducer {
  static defaultState = {
    total: 0,
    markAsUnreadEnabled: null,
    discussionWith: null,
    discussions: []
  };

  constructor() {
    super(Discussion.defaultState);

    this.actionMap = {
      [GET.RESET]: this.clearMessages,
      [GET.SUCCESS]: this.getMessages,
      [CREATE.SUCCESS]: this.appendMessage,
    };
  }

  appendMessage = (state, action) => {
    return Object.assign({}, state, {
      total: state.total + 1,
      discussions: [...state.discussions, action.payload]
    })
  }

  getMessages = (state, action) => {
    return action.payload;
  };

  clearMessages = () => {
    return Discussion.defaultState;
  };
}
export default new Discussion().reducer;
